import type { MembershipTier, Permission, PlatformRole } from './types';

export const allPermissions: Permission[] = [
  'demand:create',
  'demand:bid',
  'demand:manage-own',
  'talent:contact',
  'course:vip:view',
  'project:create',
  'project:manage-own',
  'enterprise:manage',
  'user:manage',
];

const rolePermissions: Record<PlatformRole, Permission[]> = {
  creator: ['demand:bid'],
  client: ['demand:create', 'demand:manage-own', 'talent:contact', 'project:create', 'project:manage-own'],
  enterprise_manager: [
    'demand:create',
    'demand:manage-own',
    'talent:contact',
    'project:create',
    'project:manage-own',
    'enterprise:manage',
  ],
  admin: allPermissions,
};

const membershipRank: Record<MembershipTier, number> = {
  free: 0,
  pro: 1,
  enterprise: 2,
};

const verifiedPermissions = new Set<Permission>([
  'demand:create',
  'demand:bid',
  'project:create',
  'enterprise:manage',
]);

export function getUserRoles(user: Api.Account.AccountResponse | null): PlatformRole[] {
  if (!user) return [];
  const accountType = (user.account_type || '').toUpperCase();
  return accountType === 'ENTERPRISE'
    ? ['enterprise_manager', 'client']
    : ['creator'];
}

export function getUserMembershipTier(user: Api.Account.AccountResponse | null): MembershipTier {
  if (!user) return 'free';
  const sub = user.membership?.subscriptions?.[0];
  if (sub?.plan_id === 'pro' || sub?.plan_id === 'vip') return 'pro';
  if (sub?.plan_id === 'enterprise') return 'enterprise';
  return 'free';
}

export function hasRole(user: Api.Account.AccountResponse | null, role: PlatformRole): boolean {
  if (!user) return false;
  return getUserRoles(user).includes(role);
}

export function hasMembership(user: Api.Account.AccountResponse | null, tier: MembershipTier): boolean {
  if (!user) return false;
  const currentTier = getUserMembershipTier(user);
  return membershipRank[currentTier] >= membershipRank[tier];
}

export function canUser(user: Api.Account.AccountResponse | null, _permission: Permission): boolean {
  if (!user) return false;
  return true;
}

